<script setup>
import { useLocalizationStore } from '../../stores/localizationStore';
import Icon from "../Common/Icon.vue";

const { $trans, $localize } = useLocalizationStore();

const props = defineProps({
    activeCategory: Object,
});
</script>

<template>
    <div class="flex items-center gap-x-3 text-gray-600">
        <router-link 
            :to="{ name: 'start' }"
            class="hover:text-secondary transition-colors"
        >
            <Icon name="home" class="size-5 4k:size-6" />
        </router-link>

        <Icon name="caret-right" class="size-2 4k:size-4" />

        <router-link
            :to="{ name: 'category', params: { categoryId: props.activeCategory.id } }"
            class="r-text-16 -mb-1 hover:text-secondary transition-colors"
            v-text="$localize(props.activeCategory.title)"
        >
        </router-link>

        <Icon name="caret-right" class="size-2 4k:size-4" />

        <p class="r-text-16 text-white -mb-1" v-text="$trans('breadcrumbs.stories')"></p>
    </div>
</template>
